import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Public API calls
export const getProjectInfo = async () => {
  const response = await axios.get(`${API}/project-info`);
  return response.data;
};

export const getAbout = async () => {
  const response = await axios.get(`${API}/about`);
  return response.data;
};

export const getPartners = async () => {
  const response = await axios.get(`${API}/partners`);
  return response.data;
};

export const getActivities = async () => {
  const response = await axios.get(`${API}/activities`);
  return response.data;
};

export const getResources = async () => {
  const response = await axios.get(`${API}/resources`);
  return response.data;
};

export const getDissemination = async () => {
  const response = await axios.get(`${API}/dissemination`);
  return response.data;
};

export const getContact = async () => {
  const response = await axios.get(`${API}/contact`);
  return response.data;
};

// Admin API calls
export const verifyPassword = async (password) => {
  const response = await axios.post(`${API}/admin/verify-password`, { password });
  return response.data;
};

export const updateProjectInfo = async (data) => {
  const response = await axios.put(`${API}/admin/project-info`, data);
  return response.data;
};

export const updateAbout = async (data) => {
  const response = await axios.put(`${API}/admin/about`, data);
  return response.data;
};

export const createPartner = async (data) => {
  const response = await axios.post(`${API}/admin/partners`, data);
  return response.data;
};

export const updatePartner = async (id, data) => {
  const response = await axios.put(`${API}/admin/partners/${id}`, data);
  return response.data;
};

export const deletePartner = async (id) => {
  const response = await axios.delete(`${API}/admin/partners/${id}`);
  return response.data;
};

export const createActivity = async (data) => {
  const response = await axios.post(`${API}/admin/activities`, data);
  return response.data;
};

export const updateActivity = async (id, data) => {
  const response = await axios.put(`${API}/admin/activities/${id}`, data);
  return response.data;
};

export const deleteActivity = async (id) => {
  const response = await axios.delete(`${API}/admin/activities/${id}`);
  return response.data;
};

export const createResource = async (data) => {
  const response = await axios.post(`${API}/admin/resources`, data);
  return response.data;
};

export const updateResource = async (id, data) => {
  const response = await axios.put(`${API}/admin/resources/${id}`, data);
  return response.data;
};

export const deleteResource = async (id) => {
  const response = await axios.delete(`${API}/admin/resources/${id}`);
  return response.data;
};

export const updateDissemination = async (data) => {
  const response = await axios.put(`${API}/admin/dissemination`, data);
  return response.data;
};

export const updateContact = async (data) => {
  const response = await axios.put(`${API}/admin/contact`, data);
  return response.data;
};

// File upload API calls
export const uploadFile = async (file, category = 'resources', subcategory = null, title = null, description = null) => {
  const formData = new FormData();
  formData.append('file', file);
  
  let url = `${API}/admin/upload?category=${category}`;
  if (subcategory) url += `&subcategory=${subcategory}`;
  if (title) url += `&title=${encodeURIComponent(title)}`;
  if (description) url += `&description=${encodeURIComponent(description)}`;
  
  const response = await axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const getUploadedFiles = async (category = null, subcategory = null) => {
  let url = `${API}/admin/uploads`;
  const params = [];
  if (category) params.push(`category=${category}`);
  if (subcategory) params.push(`subcategory=${subcategory}`);
  if (params.length > 0) url += `?${params.join('&')}`;
  
  const response = await axios.get(url);
  return response.data;
};

export const getFilesByCategory = async (category, subcategory = null) => {
  let url = `${API}/files/${category}`;
  if (subcategory) url += `?subcategory=${subcategory}`;
  const response = await axios.get(url);
  return response.data;
};

export const updateFileMetadata = async (fileId, data) => {
  const params = new URLSearchParams();
  if (data.title !== undefined) params.append('title', data.title);
  if (data.description !== undefined) params.append('description', data.description);
  if (data.category !== undefined) params.append('category', data.category);
  if (data.subcategory !== undefined) params.append('subcategory', data.subcategory);
  
  const response = await axios.put(`${API}/admin/uploads/${fileId}?${params.toString()}`);
  return response.data;
};

export const deleteUploadedFile = async (fileId) => {
  const response = await axios.delete(`${API}/admin/uploads/${fileId}`);
  return response.data;
};

export const getCategories = async () => {
  const response = await axios.get(`${API}/categories`);
  return response.data;
};

export const getFileUrl = (filename) => {
  return `${API}/uploads/${filename}`;
};
